//import 'bootstrap';

import 'bootstrap/js/src/collapse';